import React, { useState } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import SmoothScroll from "@/components/SmoothScroll";

export default function SiteLayout() {
  const [manageOpen, setManageOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F8F7F4] text-[#1A2421]">
      <SmoothScroll />
      <Header />
      <main>
        <Outlet context={{ openCookieManager: () => setManageOpen(true) }} />
      </main>
      <Footer onManageCookies={() => setManageOpen(true)} />
      <CookieBanner forceOpen={manageOpen} onDismiss={() => setManageOpen(false)} />
    </div>
  );
}

export function useSiteContext() {
  return useOutletContext();
}
